module.exports = __webpack_public_path__ + "img/HTCC-AB02S.2ef38e11.jpg";